import Swiper from "swiper"
import 'swiper/css';
import {Autoplay, Pagination, Navigation} from 'swiper/modules';

const initHeroSwiper = () => {
    const containers = document.querySelectorAll<HTMLElement>('.js-hero');

    if (!containers) {
        return
    }

    containers.forEach((container: HTMLElement) => {
        new Swiper(container, {
            modules: [Autoplay, Pagination],
            slidesPerView: 1,
            autoplay: {
                delay: 2500,
                disableOnInteraction: false,
            },
            pagination: {
                el: container.querySelector<HTMLElement>('.swiper-pagination'),
            },
            breakpoints: {
                640: {
                    slidesPerView: 1,
                },
                1024: {
                    slidesPerView: 1,
                },
            },
        });
    });
}

const initUspsSwiper = () => {
    const containers = document.querySelectorAll<HTMLElement>('.js-usps');

    if (!containers) {
        return
    }

    containers.forEach((container: HTMLElement) => {
        new Swiper(container, {
            slidesPerView: 1,
            loop: true,
            modules: [Autoplay],
            autoplay: {
                delay: 2500,
                disableOnInteraction: false,
            },
            breakpoints: {
                640: {
                    slidesPerView: 1,
                },
                1024: {
                    slidesPerView: 4,
                },
            },
        });
    });
}

const initProductSwiper = () => {
    const containers = document.querySelectorAll<HTMLElement>('.js-products');

    if (!containers) {
        return
    }

    containers.forEach((container: HTMLElement) => {
        new Swiper(container, {
            slidesPerView: 1,
            spaceBetween: 20,
            modules: [Pagination],
            pagination: {
                el: container.querySelector<HTMLElement>('.swiper-pagination'),
            },
            breakpoints: {
                320: {
                    slidesPerView: 1.5,
                },
                640: {
                    slidesPerView: 2,
                },
                1024: {
                    slidesPerView: 4,
                },
            },
        });
    });
}


const initReviewSwiper = () => {
    const containers = document.querySelectorAll<HTMLElement>('.js-reviews-slider');

    if (!containers) {
        return
    }

    containers.forEach((container: HTMLElement) => {
        new Swiper(container, {
            slidesPerView: 1,
            spaceBetween: 0,
            modules: [Pagination],
            pagination: {
                el: container.querySelector<HTMLElement>('.swiper-pagination'),
            },
        });
    });
}

export default () => {
    initHeroSwiper()
    initUspsSwiper()
    initProductSwiper()
    initReviewSwiper()
}
